export class AreaConstants {
    static readonly Ageing = 'Ageing';
    static readonly Annexure = 'Annexure';
    static readonly AuditLog = 'AuditLog';
    static readonly ClaimData = 'ClaimData';
    static readonly Client = 'Client';
    static readonly ClientArea = 'ClientArea';
    static readonly Endorsement = 'Endorsement';
    static readonly DeclarationReports = 'DeclarationReports';
    static readonly RenewalReports = 'RenewalReports';
    static readonly AdminReports = 'AdminReports';
    static readonly ExchangeRate = 'ExchangeRate';
    static readonly Matching = 'Matching';
    static readonly Performance = 'PerformanceData';
    static readonly PolicyGroup = 'PolicyGroup';
    static readonly PopiData = 'PopiData';
    static readonly PowerBi = 'PowerBI';
    static readonly PremiumData = 'PremiumData';
    static readonly Sales = 'Sales';
    static readonly Tenant = 'Tenant';
    static readonly User = 'User';
    static readonly Role = 'Role';
}